export const buildProcessUrl = (
  hostUrl: string,
  team: string,
  processId: string
) => `${hostUrl}/api/${team}/forms/${processId}`;
